<template>
  <div class="my-0 mx-auto ans-mw">
    <div class="o-alert mb-0 mt-0" :class="'o-alert--' + type" role="alert" :hidden="warning_dismissed">
      <div class="o-alert__icon">
          <svg :class="'svg-icon svg-' + icon" aria-hidden="true" focusable="false"><use :xlink:href="'/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#' + icon"></use></svg>
      </div>

      <slot></slot>

      <!-- collapseable content -->
      <div v-if="$slots.collapseable_content">
        <button v-if="collapsed" class="btn-link" @click="collapse(false)">
          Voir plus
        </button>
        
        <div v-if="!collapsed" class="my-1">
          <slot name="collapseable_content"></slot>
          <button class="btn-link" @click="collapse(true)">
                Masquer
                <svg class="svg-icon svg-angle-up" aria-hidden="true" focusable="false">
                  <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#angle-up"></use>
                </svg>
          </button>
        </div>
      </div>
      
      <button v-if="dismissable" type="button"     class=" btn btn--close btn--icon-only" @click="warning_dismissed = true">
        <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
          <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#close"></use>
        </svg>
        <span class="sr-only">Masquer ce message</span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "AlertMessage",

  data() {
    return {
      warning_dismissed: false,
      icon: 'warning',
      collapsed: true
    }
  },

  props: {
    dismissable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'warning',
    }
  },

  created() {
    switch (this.type) {
      case 'error':
        this.icon = 'circle-cross'
        break;

      case 'info':
        this.icon = 'circle-info'
        break;
    }
  },

  methods: {
    collapse(collapsed) {
      this.collapsed = collapsed;
    }
  }
}
</script>

<style scoped>

</style>